import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=1492d00a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PriceFilter.vue?vue&type=script&lang=ts"
export * from "./PriceFilter.vue?vue&type=script&lang=ts"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=1492d00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492d00a",
  null
  
)

export default component.exports